import axios from "axios";
import Cookies from "js-cookie";
import Toasty from "../../theme/components/Toasty";
import { removeToken, removeUserData } from "./jwtService";

axios.interceptors.request.use(null, null);
axios.interceptors.response.use(null, (error) => {
  if (error?.code === "ERR_NETWORK") {
    Toasty.error('خطا در برقراری اتصال اینترنت');
    return Promise.reject(error);
  }
  if (error?.response?.status === 401) {
    Toasty.error("لطفا مجدد لاگین کنید");
    removeToken();
    removeUserData();
    const currentUrl = window?.location?.pathname?.split("/")[1];
    if (currentUrl === "drive") {
      window.location.href = "/drive/login";
    } else {
      window.location.reload();
    }
  }
});
axios.defaults.headers.common["Authorization"] =
  "Bearer " + Cookies.get("access-token");

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
};
